type HttpMethod = "POST" | "GET" | "PUT" | "DELETE";

interface Header {
  name: string;
  value: string;
}

interface BodyParam {
  name: string;
  type: "string" | "number" | "object" | "array";
  description: string;
  optional: boolean;
  default?: string | number;
}

export enum SlideType {
  POINTS = "Points",
  STATISTICS = "Statistics",
  TIMELINE = "Timeline",
  IMAGES = "Images",
  TABLES = "Tables",
  PEOPLE = "People",
  GRAPHS = "Graphs",
  TEXTANDIMAGE = "TextandImage",
}


export interface PointsData {
  slideName: string;
  pointers: string[];
}

export interface StatisticsData {
  slideName: string;
  statistics: Array<{
    label: string;
    value: string;
    period: string;
  }>;
}

export interface TimelineData {
  slideName: string;
  events: Array<{
    date: string;
    title: string;
    description: string;
  }>;
}

export interface ImagesData {
  slideName: string;
  images: Array<{
    url: string;
    caption: string;
    description: string;
  }>;
}

export interface TablesData {
  slideName: string;
  headers: string[];
  rows: string[][];
}

export interface PeopleData {
  slideName: string;
  people: Array<{
    name: string;
    role: string;
    bio: string;
    image: string;
    linkedin: string;
  }>;
}

export interface GraphsData {
  slideName: string;
  chartType: string;
  chartData: {
    labels: string[];
    datasets: Array<{
      label: string;
      data: number[];
      borderColor: string;
      backgroundColor: string;
    }>;
  };
}

export interface TextandImageData {
  slideName: string;
  header1: string;
  image: string;
  overview: string;
  title: string;
}



export type SlideDataType =
  | PointsData
  | StatisticsData
  | TimelineData
  | ImagesData
  | TablesData
  | PeopleData
  | GraphsData
  | TextandImageData;


export interface SlideColors {
  primaryColor: string;
  secondaryColor: string;
}


export interface DynamicRequestBody {
  type: SlideType | string;
  title: string;
  data: SlideDataType;
  presentationID: string;
  documentName: string;
  creativity: number;
  colors: SlideColors;
  theme: string;
  language: string;
  websiteUrl: string;
}


export interface SlideTypeConfig {
  title: string;
  data: SlideDataType;
}

export interface SlideTypeConfigs {
  [key: string]: SlideTypeConfig;
}

interface EndpointMode {
  id: string;
  modeTitle: string;
  method: HttpMethod;
  path: string;
  description: string;
  request: Record<string, any>;
  response: Record<string, any>;
  availablelanguages?: string;
}

export interface Endpoint {
  id: string;
  title: string;
  description: string;
  method?: HttpMethod;
  path?: string;
  headers?: Header[];
  bodyParams?: BodyParam[];
  request?: Record<string, any>;
  response?: Record<string, any>;
  availablelanguages?: string;
  modes?: EndpointMode[];
}

export interface ApiConfig {
  title: string;
  description: string;
  gettingStarted: {
    apiKey: string;
    authentication: string;
  };
  endpoints: Endpoint[];
  support: {
    email: string;
    helpCenterUrl: string;
  };
}
